import { Box } from '@mui/material';

import './HeaderSeparator.scss';

export const HeaderSeparator = () => <Box className="header-separator" />;
